import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { StripeProvider } from 'react-stripe-elements';

import { Provider } from 'react-redux';
import store from '../redux/store';

// components
import Header from './Header';
import Landing from './Landing/Landing';
import Support from './Support';
import Login from './Login/Login';
import Register from './Register/Register';
import InvalidLink from './Register/InvalidLink';
import Dashboard from './Dashboard/Dashboard';
import NotFound from './NotFound';
import ExerciseReview from './Dashboard/Exercises/ExerciseReview';
import CurrentExercise from './Dashboard/Exercises/CurrentExercise';
import TermsOfService from './TermsOfService';
import CookiePolicy from './CookiePolicy';

const App = () => (
  <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
    <Router>
      <LastLocationProvider>
        <Provider store={store}>
          <div>
            <Header />
            <Switch>
              <Route exact path="/" component={Landing} />
              <Route path="/support" component={Support} />
              <Route path="/login" component={Login} />
              <Route path="/register" component={Register} />
              <Route path="/profile" component={Dashboard} />
              <Route path="/invalid-link" component={InvalidLink} />
              <Route path="/exercise-review" component={ExerciseReview} />
              <Route path="/exercise" component={CurrentExercise} />
              <Route path="/terms-of-service" component={TermsOfService} />
              <Route path="/cookie-policy" component={CookiePolicy} />
              <Route component={NotFound} />
            </Switch>
          </div>
        </Provider>
      </LastLocationProvider>
    </Router>
  </StripeProvider>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js